import React, { useState } from 'react';

import { AmazonProfile } from '../../models/Profile';

import './Setup.exludeBusiness.scss';

import { useMutation } from '@apollo/client';
import { graphqlSchema } from '../../services/graphql.schema';
import GraphQlClient from '../../services/graphql';
import sharedToasterSubject from '../../services/shared.toasterSubject';
import SwitchCheckbox from '../Forms/SwtichCheckbox';

function SetupExcludeBusiness({ amazonProfile }: { amazonProfile: AmazonProfile }) {

    const [excludeBusinessOrders, setExcludeBusinessOrders] = useState(amazonProfile.excludeBusinessOrders);
    
    const [setExcludeBusinessOrdersEnabled] = useMutation(graphqlSchema.PROFILE.SETUP.setExcludeBusinessOrders, {
        onCompleted: ({ setExcludeBusinessOrders }) => {
            console.log('Updated Exclude Business: ', setExcludeBusinessOrders);
            GraphQlClient.modifyClientMLprofile(setExcludeBusinessOrders);
            sharedToasterSubject.next({ type: 'confirm', message: `Actualizó su preferencia de exclusión de pedidos empresariales` });
        },
        onError: () => {
        }
    })

    const saveEnabled = () => {
        
        setExcludeBusinessOrders(!excludeBusinessOrders);
        setExcludeBusinessOrdersEnabled({
            variables: {
                excludeBusinessOrders: !excludeBusinessOrders
            }
        })
    }

    return (
        <div className="card" id="SetupExcludeBusiness">
            <div className="title">
                <h4>Excluir pedidos empresariales (B2B)</h4>
                <SwitchCheckbox onChange={saveEnabled} value={excludeBusinessOrders} />
            </div>
            <div className="content">
                <p>
                    Al activar esta opción se excluirán los pedidos de empresa a empresa (B2B) de ser facturados por FiscalPOP. 
                </p>
                <p>
                    Los pedidos empresariales se identifican automáticamente y no serán procesados para facturación cuando esta opción esté activada.
                </p>
                <p>
                    <b>Solo activa esta opción si estás facturando estos pedidos a través de Amazon Services</b>.
                </p>
            </div>
        </div>
    )
}

export default SetupExcludeBusiness;
